import type { ReasoningConfig, ReasoningEffort } from "@/types";

/**
 * True only for a new chat whose pending reasoning effort the active model does not accept.
 * An open chat is never touched: models may still be loading when the session arrives, and
 * dropping its stored value would save "Default" over the user's choice.
 */
export function shouldDropEffort(effort: string | null, config: ReasoningConfig | null, hasSession: boolean): boolean {
  if (hasSession || !effort) return false;
  return !config?.supportedEfforts.includes(effort as ReasoningEffort);
}
